export default __webpack_public_path__ + "static/media/hm-ttg-img.46f87b99.webp";